import { render, staticRenderFns } from "./IndustrialProcessesMainSection.vue?vue&type=template&id=b9aa0334"
import script from "./IndustrialProcessesMainSection.vue?vue&type=script&lang=js"
export * from "./IndustrialProcessesMainSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports